import type { DefaultValue } from '../../common/data.d';

const defaultValue: DefaultValue = {
  elementTypeEnum: 'add',
  componentNameKey: 'common.operation.add',
  componentName: '添加',
};

export default defaultValue;